import { PageHeader } from "@/components/PageHeader";
import { useTheme } from "@/contexts/ThemeContext";
import { cn } from "@/lib/utils";

export default function SettingsPage() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="container-elegant page-padding">
      <PageHeader title="Configurações" />

      <section className="max-w-lg">
        <h2 className="text-xs font-light tracking-widest uppercase text-primary-600 dark:text-primary-400 mb-6">
          Aparência
        </h2>
        <p className="text-sm font-light text-primary-600 dark:text-primary-400 mb-6">
          Escolha o tema da interface administrativa
        </p>

        <div
          className="inline-flex border border-primary-200 dark:border-primary-800"
          role="radiogroup"
          aria-label="Tema"
        >
          <button
            type="button"
            role="radio"
            aria-checked={theme === "light"}
            onClick={() => setTheme("light")}
            className={cn(
              "px-8 py-3 text-xs font-light tracking-widest uppercase transition-colors duration-300",
              theme === "light"
                ? "bg-primary-800 dark:bg-white text-white dark:text-primary-950"
                : "bg-transparent text-primary-700 dark:text-primary-300 hover:bg-primary-100 dark:hover:bg-primary-800"
            )}
          >
            Claro
          </button>
          <button
            type="button"
            role="radio"
            aria-checked={theme === "dark"}
            onClick={() => setTheme("dark")}
            className={cn(
              "px-8 py-3 text-xs font-light tracking-widest uppercase transition-colors duration-300 border-l border-primary-200 dark:border-primary-800",
              theme === "dark"
                ? "bg-primary-800 dark:bg-white text-white dark:text-primary-950"
                : "bg-transparent text-primary-700 dark:text-primary-300 hover:bg-primary-100 dark:hover:bg-primary-800"
            )}
          >
            Escuro
          </button>
        </div>
      </section>
    </div>
  );
}
